import { render, staticRenderFns } from "./standardDetails.vue?vue&type=template&id=d6c53116&scoped=true&"
import script from "./standardDetails.vue?vue&type=script&lang=js&"
export * from "./standardDetails.vue?vue&type=script&lang=js&"
import style0 from "./standardDetails.vue?vue&type=style&index=0&id=d6c53116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c53116",
  null
  
)

export default component.exports